import { Link, useParams } from "react-router-dom";

const Footer = () => {
    const { lang } = useParams();
    return (<footer className="bottom-0 bg-slate-50 border-t border-slate-100 print:!hidden">
        <div className="grid md:grid-cols-4 gap-4 mx-auto w-full max-w-screen-xl p-4 py-6 lg:py-8">
            <div className="mb-4">
                <img src="/images/logo-footer.png" alt="Aronium" className="me-3" />
            </div>

            <div>
                <h2 className="mb-6 text-sm font-semibold text-gray-900 dark:text-gray-200 uppercase">Support</h2>
                <ul className="text-gray-500">
                    <li className="mb-4"><Link to={`/${lang}/download`}>Downloads</Link></li>
                    <li className="mb-4"><Link to={`/${lang}/plugins`}>Plugins</Link></li>
                    <li className="mb-4"><Link to={`/${lang}/faq`}>FAQ</Link></li>
                    <li className="mb-4"><a href="https://help.aronium.com/hc">Help center</a></li>
                    <li className="mb-4"><Link to={`/${lang}/release-notes`}>Release notes</Link></li>
                </ul>
            </div>

            <div>
                <h2 className="mb-6 text-sm font-semibold text-gray-900 dark:text-gray-200 uppercase">Company</h2>
                <ul className="text-gray-500">
                    <li className="mb-4"><Link to={`/${lang}/impressum`}>Impressum</Link></li>
                    <li className="mb-4"><Link to={`/${lang}/terms-of-use`}>Terms of use</Link></li>
                    <li className="mb-4"><Link to={`/${lang}/privacy-policy`}>Privacy policy</Link></li>
                </ul>
            </div>

            <div>
                <h2 className="mb-6 text-sm font-semibold text-gray-900 dark:text-gray-200 uppercase">Contact</h2>
                <ul className="text-gray-500">
                    <li className="mb-4"><Link to={`/${lang}/contact`}>Contact us</Link></li>
                    <li className="mb-4"><Link to={`/${lang}/partners`}>Find a partner</Link></li>
                    <li className="mt-4"><i className="fa fa-envelope text-gray-500 mr-1"></i>{" "} office@aronium.com</li>
                    <li className="mt-2 text-gray-500 mb-0"><i className="fa fa-map-marker text-gray-500 mr-1"></i>
                        <span className=" pl-2">Akazienstraße 3a,</span></li>
                    <li className="text-gray-500 pl-6">10823 Berlin, Germany</li>
                </ul>
            </div>
        </div>

        <div className="flex justify-left md:justify-center md:items-center pb-4 mx-auto w-full max-w-screen-xl px-4">
            <img src="/images/payments-small.png" alt="We accept all major payment types like Visa, Mastercard, Amex and PayPal" />
        </div>

        <hr className="border-gray-200 dark:border-slate-700 mx-auto w-full max-w-screen-xl" />

        <div className="sm:flex sm:items-center sm:justify-between mx-auto w-full max-w-screen-xl px-4 py-10">
            <span className="text-sm text-gray-500 sm:text-center">© {(new Date().getFullYear())} Aronium GmbH. All Rights Reserved.
            </span>
            <div className="flex mt-4 gap-x-6 sm:justify-center sm:mt-0 text-gray-500">
                <a href="https://www.facebook.com/Aronium" target="_blank" rel="noreferrer" className="hover:border-blue-500 hover:text-blue-500"><svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" className="h-4 w-4" viewBox="0 0 24 24"><path d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z" /></svg></a>
                <a href="https://x.com/AroniumHQ" target="_blank" rel="noreferrer" className="hover:border-slate-900 hover:text-slate-900"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="currentColor" className="w-4 h-4"><path fill="none" d="M0 0h24v24H0z"></path><path d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"></path></svg></a>
                <a href="https://www.youtube.com/@Aronium" target="_blank" rel="noreferrer" className="hover:border-red-500 hover:text-red-500"><svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" className="w-4 h-4" width="24" height="24" viewBox="0 0 24 24"><path d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z" /></svg></a>
            </div>
        </div>
    </footer>
    );
}

export default Footer;